module.exports = __webpack_public_path__ + "img/private@3x.ce8cae00.png";